export const classNames = (...classes: string[]) => {
  return classes.join(" ");
};

export const getGolfPlayerCategory = (
  ageCategory: "Senior" | "NotSenior" | "Above 60" | "Below 60" | undefined,
  gender: "Male" | "Female" | undefined
): "M" | "S" | "L" => {
  if (ageCategory === "Senior" || ageCategory === "Above 60") {
    return "S";
  } else if (gender === "Male") {
    return "M";
  } else {
    return "L";
  }
};

export const getDisplayRole = (role: string) => {
  switch (role) {
    case "player":
      return "Player";
    case "nonPlayingTeamOwner":
    case "teamOwner":
      return "Owner";
    case "playingTeamOwner":
      return "Playing Team Owner";
    case "admin":
      return "Admin";
    case "coreMember":
      return "Core Member";
    default:
      return role;
  }
};

export const getDisplayInviteStatus = (status: string) => {
  switch (status) {
    case "accepted":
      return "Accepted";
    case "rejected":
      return "Rejected";
    case "pending":
      return "Pending";
    case "rejectedAutomatically":
      return "User chose another team";
    case "expired":
      return "Expired";
    case "declinedByOwner":
      return "Declined by Owner";
    default:
      return status;
  }
};

export const getDisplayInviteRole = (type: string) => {
  switch (type) {
    case "owner":
    case "teamOwner":
      return "Owner";
    case "coreMember":
      return "Player";
    default:
      return type;
  }
};

export const getUserFullName = (user: any) => {
  return `${user.title} ${user.firstName} ${user.lastName}`;
}


export const exportToCsv = (filename: string, rows: { [key: string]: any }[]) => {
  if (!rows || !rows.length) {
    return;
  }

  const separator = ",";
  const keys = Object.keys(rows[0]);
  const csvContent =
    keys.join(separator) +
    "\n" +
    rows
      .map(row => {
        return keys
          .map(key => {
            let cell = row[key] === null || row[key] === undefined ? "" : row[key];
            cell = cell instanceof Date ? cell.toLocaleString() : cell.toString().replace(/"/g, '""');
            if (cell.search(/("|,|\n)/g) >= 0) {
              cell = `"${cell}"`;
            }
            return cell;
          })
          .join(separator);
      })
      .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};